function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_4198",
  "data-name": "Path 4198",
  d: "M5.256,14.82V12.4a1.126,1.126,0,0,1,1.124-1.12H8.658A1.126,1.126,0,0,1,9.79,12.4h0v2.429a.967.967,0,0,0,.949.962h1.519A2.728,2.728,0,0,0,15,13.075h0V6.188a1.926,1.926,0,0,0-.759-1.5L9.046.541a2.511,2.511,0,0,0-3.114,0L.759,4.691A1.911,1.911,0,0,0,0,6.2v6.88a2.728,2.728,0,0,0,2.742,2.714H4.261a.975.975,0,0,0,.98-.97h0",
  transform: "translate(0.75 0.848)",
  fill: "none",
  stroke: "#f6c244",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  fillRule: "evenodd"
});

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 17.388,
    viewBox: "0 0 16.5 17.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4000339d.svg";
export { ForwardRef as ReactComponent };